import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      width: 382
    },
    "& .MuiDialogTitle-root": {
      padding: "5px 0 3px 16px",
      borderBottom: " 1px solid #797979"
    },
    "& .MuiTypography-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 43
    },
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: "calc(100% - 104px)",
      margin: "76px auto 28px",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        maxHeight: "calc(100% - 158px)",
        margin: "115px 16px 43px"
      }
    }
  },
  headerTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  dialogContent: {
    padding: 0
  },
  titleText: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 18
  }
}));
